import { getResolvedHref } from 'vue-matomo/src/utils'
import router from '../router'
import event from './event'

const tracking = {
    blah() {
        console.log(this)
    },

    event,

    pageViewByTitle(title, routeInformation) {
        const { from, to } = routeInformation
        const url = getResolvedHref(router, to.fullPath)
        const referrerUrl = from && from.fullPath
            ? getResolvedHref(router, from.fullPath)
            : undefined

        if (referrerUrl) {
            window._paq.push(['setReferrerUrl', referrerUrl])
        }
        if (url) {
            window._paq.push(['setCustomUrl', url])
        }

        window._paq.push(['trackPageView', title])
    },

    impressionWithinNode(node) {
        window._paq.push(['trackContentImpressionsWithinNode', node])
    },
}

export default tracking
